// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__29KYm","label":"Completed_label__E23dl"};